import { render, staticRenderFns } from "./CollectionSummary.vue?vue&type=template&id=7b8d4368&scoped=true"
import script from "./CollectionSummary.vue?vue&type=script&lang=js"
export * from "./CollectionSummary.vue?vue&type=script&lang=js"
import style0 from "./CollectionSummary.vue?vue&type=style&index=0&id=7b8d4368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8d4368",
  null
  
)

export default component.exports